var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103 47.9743V52.5283C102.994 63.2026 99.5025 73.589 93.0466 82.1383C86.5908 90.6877 77.5164 96.9421 67.1768 99.9686C56.8371 102.995 45.7863 102.632 35.6723 98.9325C25.5584 95.2333 16.9233 88.3965 11.0548 79.4418C5.18633 70.4871 2.39896 59.8942 3.10838 49.2431C3.81781 38.5919 7.98603 28.4531 14.9914 20.3388C21.9968 12.2245 31.4639 6.56947 41.9809 4.21706C52.498 1.86464 63.5013 2.9409 73.35 7.28533M103 12.9283L53 62.4778L38 47.6278",
    stroke: "#60E085",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.b817929112ce6d46a4afd9283a068d38.svg";
export { ForwardRef as ReactComponent };